module.exports = __webpack_public_path__ + "fonts/line-awesome.8b129059.woff";